import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import api from '../services/api';

export default function Plans() {
  const [showPricing, setShowPricing] = useState(true);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getPublicPlans()
      .then(res => setPlans(res.plans || []))
      .catch(err => console.error('Error loading plans:', err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-black pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h1 className="text-5xl md:text-7xl font-serif font-bold mb-8">Intelligence Subscriptions</h1>
          <p className="text-xl text-zinc-400 font-light">Continuous strategic oversight tailored to your ambition.</p>
        </div>

        {loading ? (
          <p className="text-center text-zinc-500 text-sm">Loading plans...</p>
        ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`rounded-[2.5rem] p-10 border flex flex-col transition-all duration-500 ${plan.popular ? 'bg-zinc-900 border-white scale-105' : 'bg-zinc-950 border-zinc-800'}`}
            >
              <div className="mb-10">
                {plan.popular && <span className="bg-blue-600 text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-widest mb-4 inline-block">Most Popular</span>}
                <h3 className="text-3xl font-serif font-bold mb-4">{plan.name}</h3>
                <p className="text-zinc-500 text-sm leading-relaxed h-12">{plan.description}</p>
              </div>

              <div className="mb-10">
                {showPricing ? (
                  <div>
                    <span className="text-4xl font-bold">{plan.price}</span>
                    <span className="text-zinc-600 text-xs uppercase tracking-widest ml-2">/ month</span>
                  </div>
                ) : (
                  <span className="text-2xl font-bold">Request Pricing</span>
                )}
              </div>

              <ul className="space-y-4 mb-12 flex-grow">
                {(plan.features || []).map((f, i) => (
                  <li key={i} className="flex gap-3 text-sm text-zinc-400">
                    <SafeIcon name="Check" className="w-4 h-4 text-blue-500 shrink-0 mt-0.5" />
                    {f}
                  </li>
                ))}
              </ul>

              <Link
                to="/request-review"
                className={`w-full py-4 rounded font-bold uppercase tracking-widest text-[10px] text-center transition-all ${plan.popular ? 'bg-white text-black hover:bg-zinc-200' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
              >
                {plan.cta}
              </Link>
            </div>
          ))}
        </div>
        )}

        <div className="mt-24 bg-zinc-900/50 border border-zinc-800 rounded-3xl p-12 text-center">
          <p className="text-zinc-500 text-sm italic">
            Payments are processed via secure bank transfer or preferred payment provider. Recurring billing is activated only after strategy review and contract approval.
          </p>
        </div>
      </div>
    </div>
  );
}